<div class="mb-8">

    <div class="w-full flex justify-between mt-8 mb-4">
        <app-btn-back routeTo=".." icon="fa fa-close" btnText="Cancel"></app-btn-back>
    </div>

    <div class="mb-4 border-0 w-full">
        <h1 class="font-semibold text-2xl capitalize text-primary-500">
            Update Lesson
        </h1>
    </div>

    <div class="w-full mb-6">
        <form [formGroup]="pageForm" (ngSubmit)="update()">

            <div class="mt-2 w-full">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1" for="lessonName">Lesson Name
                    *</label>
                <input type="text" name="lessonName" id="lessonName" formControlName="lessonName"
                    placeholder="Lesson Name"
                    class="rounded w-full my-auto outline-none border-0 focus:outline-none ring-0 focus:ring-0 shadow">
                <div
                    class="{{ pageForm.get('lessonName')?.invalid && (pageForm.get('lessonName')?.dirty || pageForm.get('lessonName')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-3 text-red-500 text-xs">
                    @if (pageForm.get('lessonName')?.errors?.['required']) {
                    <p>
                        Value is required
                    </p>
                    } @else if(pageForm.get('lessonName')?.errors?.['minlength'] ||
                    pageForm.get('lessonName')?.errors?.['maxlength']) {
                    <p>
                        Min 3 and max 100 characters required
                    </p>
                    }
                </div>
            </div>

            <div class="my-2 w-full">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1" for="gradeId">For Grade
                    *</label>
                <select formControlName="gradeId" id="gradeId" name="gradeId" (change)="onGradeChange($event)"
                    class="rounded w-full my-auto outline-none border-0 focus:outline-none ring-0 focus:ring-0 shadow">
                    @for (item of grades; track $index) {
                    <option [value]="item.id">{{item.gradeName}}</option>
                    }
                </select>
            </div>

            <div class="mt-4 mb-2w-full">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1" for="lessonStatus">Lesson
                    Status</label>
                <select formControlName="lessonStatus" id="lessonStatus" name="lessonStatus"
                    class="rounded w-full my-auto outline-none border-0 focus:outline-none ring-0 focus:ring-0 shadow">
                    <option value="available">Available</option>
                    <option value="unavailable">Unavailable</option>
                </select>
            </div>

            <div class="mt-4 mb-2 w-full">
                <label class="block uppercase text-blueGray-600 text-xs font-bold" for="tagField">Tags</label>
                <div class="flex flex-wrap gap-1">
                    @for (item of tags; track $index) {
                    <button (click)="removeTag($event)" type="button" data-dismissible="chip"
                        class="relative flex select-none items-center whitespace-nowrap rounded-lg bg-primary-500 py-1.5 px-3 my-1 text-xs font-bold text-white">
                        <span class="grow-0">{{item}}<i class="fa fa-close ml-2 leading-relaxed"></i></span>
                    </button>
                    }
                </div>
                <div class="flex flex-row align-middle mt-1">
                    <input formControlName="tagField" id="tagField" name="tagField" type="text"
                        class="rounded w-full my-auto outline-none border-0 focus:outline-none ring-0 focus:ring-0 shadow ease-linear transition-all duration-150" />
                    <button (click)="addTag()" type="button"
                        class="bg-primary-100 text-primary-500 basis-1/4 whitespace-nowrap rounded ml-2 text-xs px-2 border-0 focus:outline-none ring-0 focus:ring-0">Add
                        Tag</button>
                </div>
                <div
                    class="{{ pageForm.get('tagField')?.invalid && (pageForm.get('tagField')?.dirty || pageForm.get('tagField')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-3 text-red-500 text-xs">
                    @if (pageForm.get('tagField')?.errors?.['invalidValue']) {
                    <p>Invalid text</p>
                    } @else if(pageForm.get('tagField')?.errors?.['maxValuesAllowed']) {
                    <p>Max values allowed reached</p>
                    }
                </div>
            </div>

            <div class="w-full flex flex-col gap-1 mb-1">
                <label class="block uppercase text-blueGray-600 text-xs font-bold">
                    Lesson Notes Type
                </label>
                <span class="text-primary-300 text-sm">{{ pageForm.get('notesType')?.value | titlecase }}</span>
                <!-- <select (change)="onNotesTypeChange($event)"
                    class="appearance-none placeholder-blueGray-300 bg-white rounded text-sm shadow border-0 focus:ring-0 focus:outline-none w-full ease-linear transition-all duration-150">
                    @for (item of notesTypeList; track item) {
                    <option [selected]="pageForm.get('notesType')?.value == item" [value]="item"
                        class="bg-white text-primary-500 text-sm">
                        {{item}}</option>
                    }
                </select> -->
            </div>

            @if(pageForm.get('notesType')?.value == notesType.pdf && isPdfAttached){
            <div class="w-full flex flex-col gap-1 my-4">
                <label class="block uppercase text-blueGray-600 text-xs font-bold">
                    Current Lesson
                </label>
                <div class="bg-white rounded flex flex-row justify-between py-2 px-4">
                    <div class="flex flex-row items-center gap-2">
                        <i class="far fa-file-pdf text-lg text-blue-500 hover:underline"></i>
                        <div class="flex flex-col gap-1">
                            <span class="text-primary-500 font-semibold text-sm">{{ lesson?.lessonName }}</span>
                            <!-- <span class="text-primary-300 font-light text-xs">{{ lesson?.notesUrl }}</span> -->
                        </div>
                    </div>
                    <!-- @if((myRoles$ | async)?.management || (myRoles$ | async)?.faculty) {
                    <app-btn-fab (click)="onDeleteLessonPdf()" icon="fa fa-trash-can" colors="bg-gray-100 text-red-500"
                        tooltip="Delete"></app-btn-fab>
                    } -->
                </div>
            </div>
            }

            @if (pageForm.get('notesType')?.value == notesType.pdf) {
            <div class="w-full flex flex-col mt-4">
                <app-s3-document-upload #uploader label="Upload Pdf" [preSignedUrlEndpoint]="preSignedUrlEndpoint"
                    [apikey]="apiKey" [formats]="['.pdf']"
                    [cloudFrontDomain]="cloudFrontDomain"></app-s3-document-upload>
            </div>
            }

            <!-- @if (pageForm.get('notesType')?.value == notesType.text) {
            <div class="w-full mt-1 mb-4">
                <p class="text-primary-300 text-sm">Text editor will be available post lesson updation</p>
            </div>
            } -->

            <div class="flex flex-row gap-4 justify-start">
                <app-btn-submit [isDisabled]="pageForm.invalid || ((loading$ | async) ?? false) || groupId == null || (pageForm.get('notesType')?.value == notesType.pdf &&
      (lesson?.notesUrl == null || lesson?.notesUrl == '') && !uploader?.getIsAttached())"
                    [isLoading]="((loading$ | async) ?? false)" actionText="Update" icon="fa fa-save"></app-btn-submit>
            </div>

            @if(pageForm.errors) {
            <p class="text-red-500 text-xs px-2 py-1">{{ pageForm.errors | json }}</p>
            }
        </form>
    </div>
</div>